import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';

@customElement('vxc-select')
export class TSelect extends LitElement {

    static styles = css`
        :host {
            display: block;
            width: 100%;
            height: 100%;
            --border-radius: 5px;
            --sl-input-label-font-size-medium: .7rem;
            --sl-input-focus-ring-color: black;
            --sl-focus-ring-style: solid;
            --sl-focus-ring-width: 1px;
            --sl-input-border-width: 1px;
            --sl-input-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
            --sl-input-focus-ring-offset: 0px;
        }

        sl-card {
            padding: 1rem;
            width: 100%;
            height: 100%;
        }

        sl-input {
            margin-top: 1rem;
        }

        .title {
            font-weight: 600;
            font-size: .7rem;
        }

        .description {
            font-weight: 400;
            font-size: .7rem;
        }

        sl-card {
            margin: 0px;
            padding: 0px;
        }

        sl-card::part(base) {
            height: 100%;
            width: 100%;
        }

        sl-card.no-border::part(base) {
            border: none;
            box-shadow: none;
        }

    `
    @property({type: Boolean                 }) border = false
    @property({type: String                  }) title = 'Name'
    @property({type: String                  }) description = ''
    @property({type: String                  }) label = 'Label'
    @property({type: String                  }) name = 'input'
    @property({type: String                  }) type = 'text'
    @property({type: String                  }) size = 'medium'
    @property({type: Array                   }) options: Array<{ label: string; value: string }> = []
    @property({type: String                  }) value = ''
    @property({type: String                  }) placeholder = ''
    @property({type: String                  }) helptext = ''
    @property({ type: Boolean, reflect: true }) multiple: boolean = false
    @property({ type: Boolean, reflect: true }) clearable: boolean = false
    @property({ type: Boolean, reflect: true }) disabled: boolean = false
    @property({ type: Boolean, reflect: true }) readonly: boolean = false
    @property({ type: Boolean, reflect: true }) required: boolean = false   

    private onValue(event: Event) {
        const slSelect = event.target as any
        this.value = slSelect.value
        this.dispatchEvent(new CustomEvent('valueUpdated', { detail: { value: this.value } }));
    }

    render() {
        return html`
        <sl-card class=${this.border ? '' : 'no-border'}>
            <div class="title">${this.title}</div>
            <div class="description">${this.description}</div>
            <sl-select 
                id="select"
                name=${this.name} 
                label=${this.label}
                size=${this.size}
                value=${this.value} 
                hoist=true
                placeholder=${this.placeholder} 
                helpText=${this.helptext}
                ?multiple=${this.multiple}
                ?clearable=${this.clearable} 
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                @sl-change=${this.onValue}
            >
            ${(this.options||[]).map( opt => html`<sl-option value=${opt.value}>${opt.label}</sl-option>` )}
            </sl-select>
        </sl-card>
        `
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-select': TSelect
  }
}